// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3xWOS","paramInput":"JobSimulator_paramInput__1E5NV","input":"JobSimulator_input__1NWXs"};